<h2 class="nomargin">{{ overlappingProperties.length }} properties already have a payout method.</h2>

<div class="property-warn-helper">
  <p>
    Properties can only be set to pay out to one payout method. If you continue, the previous payout method will be
    replaced by the new payout method for all future bookings.
  </p>

  <!-- <p>
      <a href="#" target="_blank" class="grass-darker text__small"
        >Learn more about payouts</a
      >
    </p> -->
</div>

<div class="properties">
  <div *ngFor="let property of overlappingProperties" class="property" fxLayoutAlign="start center" fxLayoutGap="8px">
    <img class="property-img" [src]="property.picture" />
    <div fxLayout="column">
      <span>{{ property.name }}</span>
      <span class="text__small">Currently using: {{ property.payout | payoutMethodTitle }}</span>
    </div>
  </div>
</div>

<div fxLayoutAlign="space-between center">
  <sbnb-button label="Go back" type="secondary" (clicked)="backClicked.emit()"></sbnb-button>
  <sbnb-button label="Continue" (clicked)="continueClicked.emit()"></sbnb-button>
</div>
